import { useEmbarcacaoVelocidadeConsumo } from "../../../../hooks/use-embarcacao-velocidade-consumo";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  VELOCIDADE_CONSUMO_EMPTY_STATE,
  VELOCIDADE_CONSUMO_FIELDS,
  VELOCIDADE_CONSUMO_ID,
  VELOCIDADE_CONSUMO_LOADING_MESSAGE,
  VELOCIDADE_CONSUMO_TEST_ID,
  VELOCIDADE_CONSUMO_TITLE,
} from "./velocidade-consumo-section.constants";

/** Seção Velocidade e Consumo do detalhamento da embarcação: somente leitura, com os campos já formatados para a View. */
export function useVelocidadeConsumoSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, velocidadeConsumo, errorMessage, reload } =
    useEmbarcacaoVelocidadeConsumo(embarcacaoId);

  return {
    id: VELOCIDADE_CONSUMO_ID,
    title: VELOCIDADE_CONSUMO_TITLE,
    testId: VELOCIDADE_CONSUMO_TEST_ID,
    fieldsTestId: `${VELOCIDADE_CONSUMO_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: VELOCIDADE_CONSUMO_LOADING_MESSAGE,
    emptyContent: VELOCIDADE_CONSUMO_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: velocidadeConsumo
      ? latestAtualizacao([
          velocidadeConsumo.ultimaAtualizacao,
          velocidadeConsumo.atualizacaoVelocidadeConsumo,
        ])
      : undefined,
    fields: buildDetailFields(
      velocidadeConsumo,
      VELOCIDADE_CONSUMO_FIELDS,
      VELOCIDADE_CONSUMO_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
